module.exports = __webpack_public_path__ + "static/media/1002251.66542cc2.png";